import {Component} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-cancel',
  templateUrl: './modal-alert.component.html',
  styleUrls: []
})
export class ModalAlertComponent {
  id = '';
  title = '';
  texts: string[] = [];

  constructor(
    public modalRef: BsModalRef,
    private readonly modalService: BsModalService
  ) { }

  onConfirm(): void {
    this.modalService.setDismissReason(this.id + '-confirm');
    this.modalRef.hide();
  }

  onCancel(): void {
    this.modalService.setDismissReason(this.id + '-cancel');
    this.modalRef.hide();
  }
}
